import React, { useState, useEffect } from "react";
import Sidebardata from "../home/Sideebar";
import Header from "../home/header";
import Hero from "./Hero";
import Actioncard from "./Actioncard";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { setHomer } from "../../redux/slices/helperSlice";
import Loading from "../../Website/Loading";
import useFetchData from "../hooks/useFetchData";

export default React.memo(function Index() {
  const dispatch = useDispatch();
  const { scenario_id } = useParams();
  const [scenario, setScenario] = React.useState({});
  const [site, setSite] = React.useState({});
  const [products, setProducts] = React.useState([]);

  const [optimizationTab, setOptimizationTab] = React.useState(
    "microgrid-architecture"
  );
  const { homer } = useSelector((state) => state.helper);

  React.useEffect(() => {
    return () => {
      dispatch(setHomer(null));
    };
  }, []);

  const {
    data: productsData,
    error: productsError,
    isLoading: productsIsLoading,
  } = useFetchData("/products?sort_by=id&sort_direction=asc");

  React.useEffect(() => {
    if (productsData?.status) {
      setProducts(productsData.data);
    }
  }, [productsData]);

  const {
    data: scenarioData,
    error: scenarioError,
    isLoading: scenarioIsLoading,
  } = useFetchData(`/scenarios/${scenario_id}`);

  React.useEffect(() => {
    if (scenarioData?.status) {
      setScenario(scenarioData.data);
    }
  }, [scenarioData]);

  const {
    data: siteData,
    error: siteError,
    isLoading: siteIsLoading,
  } = useFetchData(
    scenarioData?.data?.site_id ? `/sites/${scenarioData.data.site_id}` : null
  );

  React.useEffect(() => {
    if (siteData?.status) {
      setSite(siteData.data);
    }
  }, [siteData]);

  const {
    data: homerData,
    error: homerError,
    isLoading: homerIsLoading,
  } = useFetchData(
    !homer &&
      (optimizationTab === "optimization-charts" ||
        optimizationTab === "system-sizing")
      ? `/system-optimization/homer-file-summary/${scenario_id}`
      : null
  );

  React.useEffect(() => {
    if (homerData?.status) {
      dispatch(setHomer(homerData.data));
    }
  }, [homerData]);

  return (
    <>
      <div className="grid grid-cols-12  ">
        <div className=" lg:col-span-2">
          <Sidebardata />
        </div>
        <div className=" transition-none col-span-12 lg:col-span-12 mr-3  ">
          <div className=" w-[85%] sm:w-[95%] ml-auto ">
            <Header />
            {scenarioIsLoading ? (
              <Loading />
            ) : (
              <>
                <Hero scenario={scenario} />
                <Actioncard
                  scenario={scenario}
                  site={site}
                  homer={homer}
                  onReceiveScenario={setScenario}
                  products={products}
                  setOptimizationTab={setOptimizationTab}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
});
